import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { createProviderToken } from '@core/common-legacy';
// eslint-disable-next-line boundaries/external
import { light, dark } from '@tellent/design-tokens';

export const SupportedThemes = { light, dark };

export type SupportedThemesT = keyof typeof SupportedThemes;
export type Theme = (typeof SupportedThemes)[SupportedThemesT];
export type ThemeName = SupportedThemesT | 'auto';

export const RECRUITEE_THEME_LS_KEY = 'recruitee-theme';
export const RECRUITEE_THEME_MIGRATED_LS_KEY = 'recruitee-theme-migrated';
export const RECRUITEE_THEME_DEFAULT = 'light';

type BackgroundSpecificTokenExtract<T> = Extract<T, `colorBg${string}`>;
export type BackgroundToken = BackgroundSpecificTokenExtract<keyof Theme>;

type EffectiveTheme = { effectiveThemeName$: Observable<SupportedThemesT> };

export const EffectiveTheme = new InjectionToken<EffectiveTheme>(
  'effectiveThemeName$ with dark or light string',
);

type TextSpecificTokenExtract<T> = Extract<T, `colorText${string}`>;
type ExtractedTextToken = TextSpecificTokenExtract<keyof Theme>;

export type TextToken = ExtractedTextToken extends never
  ? TextSpecificTokenExtract<keyof typeof SupportedThemes.light>
  : ExtractedTextToken;

export const { provide: providerEffectiveThemeFactory, inject: injectEffectiveThemeFactory } =
  createProviderToken<EffectiveTheme>('effectiveThemeName$ with dark or light string')();
